import { levelMapScene } from "@kit/map";
import { track } from "@kit/telemetry";
import { meta } from "./meta";
import { BlokScene } from "./BlokScene";
import { generateLevel } from "./core/generator";
import { THEMES } from "./i18n";

const BlokMap = levelMapScene({
  id: "blok",
  gameScene: "blok",
  title: { tr: "Blok", en: "Block" },
  accent: 0x8ac926,
  firstTheme: 1,
  track,
  describe: (n, lang) => {
    const theme = THEMES[generateLevel(n).theme]?.[lang] ?? "";
    return lang === "tr" ? `Resim teması: ${theme} · az parçada bil, 3 yıldız al` : `Picture theme: ${theme} · guess it early for 3 stars`;
  },
});

/** Embeddable game (docs/design/platform.md): the shell starts these scenes in its own Phaser instance. */
export const game = { meta, scenes: [BlokMap, BlokScene] };
